import { modulo } from './modulo';

const notes = ['a', 'a#', 'b', 'c', 'c#', 'd', 'd#', 'e', 'f', 'f#', 'g', 'g#'];

const getNoteName = (noteValue) =>
   notes[modulo(noteValue, 12)] + (Math.floor((noteValue + 9) / 12) + 4);

export { getNoteName };
